import { TranslocoModule } from '@jsverse/transloco';
import { ActionsModule } from '../../atoms/actions/actions.module';
import { ActionBarComponent } from './action-bar.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CypressDirectiveModule } from '../../../directives/cypress/cypress-directive.module';
import { CheckboxModule } from '@xt/ui-kit';

@NgModule({
  declarations: [ActionBarComponent],
  imports: [
    CommonModule,
    ActionsModule,
    TranslocoModule,
    CypressDirectiveModule,
    CheckboxModule,
  ],
  exports: [ActionBarComponent],
})
export class ActionBarModule {}
